/**
 * Advanced Settings Component Export
 *
 * @since 1.0.0
 */

export { AdvancedSettings } from './component';
export type { AdvancedSettingsData, AdvancedSettingsProps } from './types';
